import { render } from "./TransactionPage.vue?vue&type=template&id=5ff90f03&scoped=true"
import script from "./TransactionPage.vue?vue&type=script&lang=js"
export * from "./TransactionPage.vue?vue&type=script&lang=js"

import "./TransactionPage.vue?vue&type=style&index=0&id=5ff90f03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff90f03"]])

export default __exports__